export default __webpack_public_path__ + "static/slider.stadtamthall.klein-31fab6e73cf943c82651eea400afa04c.png";